module.exports = __webpack_public_path__ + "sparkles-color.8632cb670fa3560516866b3a62740fdd.svg";